<zui-map-container
 [companyId]="companyId$ | async"
 [isZoneToggleChecked]="true"
></zui-map-container>
